import { z } from "zod";
import { avatarColorSchema } from "./avatar";

export const monthlyObjectivesSchema = z.object({
  drill: z.number().min(0).nullable(),
  hseq_visit: z.number().min(0).nullable(),
  investigation: z.number().min(0).nullable(),
  observation: z.number().min(0).nullable(),
  management: z.number().min(0).nullable(),
  actions: z.number().min(0).nullable(),
});

export const upsertDepartmentSchema = z.object({
  name: z.string().min(1).max(255),
  color: avatarColorSchema,
  monthlyObjectives: monthlyObjectivesSchema.optional(),
});

export const updateDepartmentObjectivesSchema = z.object({
  departmentId: z.string().min(1),
  monthlyObjectives: monthlyObjectivesSchema,
});

export const departmentResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
  color: avatarColorSchema,
  departmentCode: z.string(),
  companyId: z.string(),
  monthlyObjectives: monthlyObjectivesSchema.nullable(),
});

export type UpsertDepartment = z.infer<typeof upsertDepartmentSchema>;
export type MonthlyObjectives = z.infer<typeof monthlyObjectivesSchema>;
export type UpdateDepartmentObjectives = z.infer<
  typeof updateDepartmentObjectivesSchema
>;
export type DepartmentResponse = z.infer<typeof departmentResponseSchema>;
